import { classifyHit } from "@/lib/geometry";

const rand = (a, b) => a + Math.random() * (b - a);

const radius = (hitType, B, F) => {
  if (hitType === "bunt") return rand(B * 0.15, B * 0.4);
  const deep = Math.random() < (hitType === "ground" ? 0.4 : 0.6);
  return deep ? rand(B * 1.8, F * (hitType === "fly" ? 0.9 : 0.8)) : rand(B * (hitType === "fly" ? 0.5 : 0.7), B * 1.5);
};

export function randomSituation(cfg) {
  const r = Math.random();
  const hitType = r < 0.5 ? "ground" : r < 0.85 ? "fly" : "bunt";
  for (;;) {
    const ang = (rand(-40, 40) * Math.PI) / 180;
    const dist = radius(hitType, cfg.base, cfg.fence);
    const tap = [Math.sin(ang) * dist, Math.cos(ang) * dist];
    const c = classifyHit(tap, cfg, hitType);
    if (!c.foul) {
      return { outs: Math.floor(Math.random() * 3), runners: Math.floor(Math.random() * 8), hitType, tap, ...c };
    }
  }
}

const norm = (job) => (job === "cutoff" ? "relay" : job);
export const sameJob = (a, b) => norm(a) === norm(b);

export const tolerance = (cfg) => cfg.base * 0.3;

export function drillSituation(d) {
  const [, , outs, runners, hitType, fielder] = d.key.split("|");
  return { outs: +outs, runners: +runners, hitType, fielder, tap: d.ball, ball: d.ball, foul: false, drill: d };
}
